import type { InnovationDiscoveryRow } from '../../productgovernance/framework';

type Props = { items?: InnovationDiscoveryRow[] };

export function InnovationDiscoveryPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.area}-${item.detail}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-400">{item.area}</p>
              <p className="text-sm font-medium">{item.detail}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold text-brand-600">{item.count}</p>
              <p className="text-xs text-slate-500">{item.status}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
